interface CustomerServiceSVGProps {
  color: string;
  style: React.CSSProperties;
}

const CustomerServiceSVG = ({ color, style }: CustomerServiceSVGProps) => (
  <svg
    style={style}
    xmlns="http://www.w3.org/2000/svg"
    width="44"
    height="50"
    viewBox="0 0 44 50"
    fill="none"
  >
    <g clipPath="url(#clip0_1586_46428)">
      <path
        d="M11.5239 19.7341V23.8887C11.5239 29.622 16.2173 34.2751 22.0001 34.2751C24.923 34.2751 27.5734 33.0806 29.4801 31.1591"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M25.143 11.425C25.143 14.2916 22.7963 16.6182 19.9049 16.6182H11.5239V15.5796C11.5239 9.84627 16.2173 5.19318 22.0001 5.19318C27.783 5.19318 32.4763 9.84627 32.4763 15.5796V23.8886C32.4763 24.2418 32.4554 24.5845 32.4239 24.9273"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M9.4288 38.4296C4.79833 38.4296 1.04785 42.1479 1.04785 46.7387V49.8546"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M42.9522 49.8546V46.7387C42.9522 42.1479 39.2018 38.4296 34.5713 38.4296"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.6668 15.5796C36.6668 7.55089 30.0983 1.03864 22.0002 1.03864C13.9021 1.03864 7.3335 7.55089 7.3335 15.5796"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.6665 15.5796H38.7617C39.9141 15.5796 40.857 16.5144 40.857 17.6569V21.8114C40.857 22.9539 39.9141 23.8887 38.7617 23.8887H36.6665V15.5796Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M5.2383 15.5796H7.33354V23.8887H5.2383C4.08592 23.8887 3.14307 22.9539 3.14307 21.8114V17.6569C3.14307 16.5144 4.08592 15.5796 5.2383 15.5796Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M36.6666 23.8887V24.9273C36.6666 26.6514 35.2628 28.0432 33.5238 28.0432H24.0952"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M22 30.1205C23.1572 30.1205 24.0953 29.1905 24.0953 28.0432C24.0953 26.896 23.1572 25.9659 22 25.9659C20.8429 25.9659 19.9048 26.896 19.9048 28.0432C19.9048 29.1905 20.8429 30.1205 22 30.1205Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M21.9999 47.7773L16.7618 38.4296H12.5713V43.6228L21.9999 48.8159L31.4284 43.6228V38.4296H27.238L21.9999 47.7773Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
    </g>
    <defs>
      <clipPath id="clip0_1586_46428">
        <rect width="44" height="50" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default CustomerServiceSVG;
